"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/vi_VN");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  announcements_a4b8ed4a: {
    message: "Nh\u1EEFng th\xF4ng b\xE1o"
  },
  assignments_1e02582c: {
    message: "B\xE0i t\u1EADp"
  },
  discussions_a5f96392: {
    message: "Th\u1EA3o lu\u1EADn"
  },
  folder_705fd2d7: {
    message: "th\u01B0 m\u1EE5c"
  },
  loading_25990131: {
    message: "\u0110ang t\u1EA3i..."
  },
  search_280d00bd: {
    message: "T\xECm ki\u1EBFm"
  }
};

_formatMessage.default.addLocale({
  vi: locale
});